import { USER_PROFILE_DATA } from '../../api/url';
import { CustomTabComponent } from '../../components/molecules/customTab';
import { getLocalStorageItem } from '../../utils/storageHelper';
import Personaldetails from './personalDetails';
export default function Profile(props) {
    var profileData = getLocalStorageItem(USER_PROFILE_DATA);
    var list = [{
            id: "1",
            name: "My Details",
            component: /*#__PURE__*/ React.createElement(Personaldetails, {
                data: profileData === null || profileData === void 0 ? void 0 : profileData.data,
                onClosePopup: props.onClosePopup
            })
        }
        // only UAT v2.5
        // { id: "2", name: "Change password", component: <Typography variant="h2" style={{display:'flex',justifyContent:'center',alignItems: 'center',height:'50vh'}}>{t("Coming Soon")}...</Typography> },
        // { id: "3", name: "Settings", component:<Typography variant="h2" style={{display:'flex',justifyContent:'center',alignItems: 'center',height:'50vh'}}>{t("Coming Soon")}...</Typography>  },
    ];
    return /*#__PURE__*/ React.createElement(CustomTabComponent
    // sx={{ display: "flex", justifyContent: 'center', width: '100%' }} // only UAT v2.5
    , {
        sx: {
            display: 'none'
        } // only UAT v2.5
        ,
        tabVariant: "standard",
        variant: "h3",
        items: list,
        showTabIndicator: true,
        bgColorApply: true
    });
}
